// fontActions.js
export const FONT_ACTIONS = {
  FONT_LOAD_STATUS: "FONT_LOAD_STATUS"
};

export const updateFontStatus = (payload) => ({
  type: FONT_ACTIONS.FONT_LOAD_STATUS,
  payload
});